<template lang="pug">
  div
    template(v-if="isCashMode()")
      settlementListCash
    template(v-else)
      settlementListCredit
</template>

<script>
import settlementListCredit from "@/views/settlement/_settlementListCredit.vue"
import settlementListCash from "@/views/settlement/_settlementListCash.vue"

export default {
  components: {
    settlementListCredit,
    settlementListCash
  },
  mounted: function() {
    this.$helpers.getSchedule()
  },
  methods: {
    isCashMode() {
      return this.$store.getters.cashMode && this.$store.getters.accountType == 2
    }
  }
};
</script>